import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, InputNumber, Button, Modal, Select } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;

class TrafficSignsTestsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Typ testu" >
          {getFieldDecorator('test', {
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                let obj = {
                  test: value
                };
                // if (value !== 'TEST1') {
                //   obj.a = '-';
                //   obj.b = '-';
                // }
                this.props.form.setFieldsValue(obj);
              }}>
              <Select.Option value="TEST1">TEST1</Select.Option>
              <Select.Option value="TEST2">TEST2</Select.Option>
              <Select.Option value="TEST3">TEST3</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Barva" >
          {getFieldDecorator('color', {
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Select
              onChange={(value) => {
                this.props.form.setFieldsValue({ color: value });
              }}>
              <Select.Option value="W"><span style={{ height: 10, width: 10, backgroundColor: 'white', borderRadius: '50%', display: 'inline-block', border: '1px solid #bbb' }}></span>{' '}White</Select.Option>
              <Select.Option value="R"><span style={{ height: 10, width: 10, backgroundColor: 'red', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Red</Select.Option>
              <Select.Option value="G"><span style={{ height: 10, width: 10, backgroundColor: 'green', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Green</Select.Option>
              <Select.Option value="B"><span style={{ height: 10, width: 10, backgroundColor: 'blue', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Blue</Select.Option>
              <Select.Option value="C"><span style={{ height: 10, width: 10, backgroundColor: 'cyan', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Cyan</Select.Option>
              <Select.Option value="M"><span style={{ height: 10, width: 10, backgroundColor: 'magenta', borderRadius: '50%', display: 'inline-block' }}></span>{' '} Magenta</Select.Option>
              <Select.Option value="Y"><span style={{ height: 10, width: 10, backgroundColor: 'yellow', borderRadius: '50%', display: 'inline-block' }}></span>{' '}Yellow</Select.Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Délka trvání [s]" >
          {getFieldDecorator('time', {
            rules: [{
              type: 'integer', message: 'Položka musí obsahovat číslo!',
            }, {
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <InputNumber
              min={1}
              max={1440} />
          )}
        </FormItem>
        {this.props.form.getFieldValue('test') === 'TEST2'
          ? <div>
            <FormItem
              {...formItemLayout}
              label="Oblast" >
              {getFieldDecorator('a', {
                rules: [{
                  required: true, message: 'Vyplňte prosím tuto položku!',
                }],
              })(
                <Select
                  onChange={(value) => {
                    this.props.form.setFieldsValue({ a: value });
                  }}>
                  <Select.Option value="C">Sloupec</Select.Option>
                  <Select.Option value="L">Řádek</Select.Option>
                </Select>
              )}
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="Pozice" >
              {getFieldDecorator('b', {
                rules: [{
                  type: 'integer', message: 'Položka musí obsahovat číslo!',
                }, {
                  required: true, message: 'Zadejte prosím tuto položku!',
                }],
              })(
                <InputNumber
                  min={1}
                  max={1440} />
              )}
            </FormItem>
          </div>
          : null}
        {this.props.form.getFieldValue('test') === 'TEST3'
          ? <div>
            <FormItem
              {...formItemLayout}
              label="Pozice X" >
              {getFieldDecorator('a', {
                rules: [{
                  type: 'integer', message: 'Položka musí obsahovat číslo!',
                }, {
                  required: true, message: 'Zadejte prosím tuto položku!',
                }],
              })(
                <InputNumber
                  min={0}
                  max={9999} />
              )}
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="Pozice Y" >
              {getFieldDecorator('b', {
                rules: [{
                  type: 'integer', message: 'Položka musí obsahovat číslo!',
                }, {
                  required: true, message: 'Zadejte prosím tuto položku!',
                }],
              })(
                <InputNumber
                  min={0}
                  max={9999} />
              )}
            </FormItem>
          </div>
          : null}
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Spustit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title="Test informační tabule"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText="Spustit"
          onOk={this.handleSubmit}>
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TrafficSignsTestsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TrafficSignsTestsForm.js